import styles from "./language-tabs.module.css";

export type LanguageTab = {
  code: string;
  label: string;
  status?: string;
  complete?: boolean;
};

export function LanguageTabs({
  items,
  value,
  onChange,
  label = "İçerik dili",
  variant = "bar",
}: {
  items: LanguageTab[];
  value: string;
  onChange: (code: string) => void;
  label?: string;
  variant?: "bar" | "compact";
}) {
  return (
    <div className={styles.root} data-variant={variant} role="tablist" aria-label={label}>
      <span className={styles.label}>Dil</span>
      <div className={styles.tabs}>
        {items.map((item) => (
          <button
            aria-selected={item.code === value}
            className={styles.tab}
            data-complete={item.complete}
            key={item.code}
            onKeyDown={(event) => {
              if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
              event.preventDefault();
              const tabs = Array.from(
                event.currentTarget.parentElement?.querySelectorAll<HTMLButtonElement>('[role="tab"]') ?? [],
              );
              const index = tabs.indexOf(event.currentTarget);
              const nextIndex = event.key === "Home"
                ? 0
                : event.key === "End"
                  ? tabs.length - 1
                  : (index + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
              tabs[nextIndex]?.focus();
              tabs[nextIndex]?.click();
            }}
            onClick={() => onChange(item.code)}
            role="tab"
            tabIndex={item.code === value ? 0 : -1}
            type="button"
          >
            <span>{item.label}</span>
            <small>{item.code.toLocaleUpperCase("tr-TR")}</small>
            {item.status ? <em>{item.status}</em> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
